module.exports = __webpack_public_path__ + "img/info_yellow.e77e98ba.svg";